export default __webpack_public_path__ + "static/media/id_protection.739bf9c2.jpg";